import { generatePath } from 'react-router';
import { joinPath } from 'src/shared/utils/joinPath';

const privateRootBasePath = '/dashboard';

export const getPrivatePath = (path: string) =>
  joinPath(privateRootBasePath, path);

export const generatePrivatePath: typeof generatePath = (...args) =>
  joinPath(privateRootBasePath, generatePath(...args));
